import { useQuery } from "@tanstack/react-query";
import { useAnalytics } from "../../../contexts/analytics/hooks";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import { backendService } from "../../../services/backend.service";
import { MC_QUERY_DEFAULTS } from "../utils";

export const useGetDailyStaffBreakdown = ({
	date,
	enabled,
	roles,
	jobs,
	shiftHours,
	laborCost,
	hideWage,
	includeProblems,
	includeLateScheduled,
	estimateMissingWage,
}: {
	date: string;
	enabled: boolean;
	roles?: string[];
	jobs?: string[];
	shiftHours?: string[];
	laborCost?: boolean;
	hideWage?: boolean;
	includeProblems?: boolean;
	includeLateScheduled?: boolean;
	estimateMissingWage: boolean;
}) => {
	const { chosenDepartment } = useHospitalData();
	const { track } = useAnalytics();
	return useQuery({
		queryKey: [
			"daily-staff-breakdown",
			chosenDepartment.department_id,
			date,
			roles,
			jobs,
			shiftHours,
			laborCost,
			hideWage,
			includeProblems,
			includeLateScheduled,
			estimateMissingWage,
		],
		queryFn: async () => {
			track("fetch_daily_staff_breakdown", {
				department_id: chosenDepartment.department_id,
				date,
				shift_hours: shiftHours?.join(","),
			});
			const result = await backendService.getDailyStaffBreakdown({
				departmentId: chosenDepartment.department_id,
				targetDate: date,
				roles,
				jobs,
				shiftHours,
				laborCost,
				hideWage,
				includeProblems,
				includeLateScheduled,
				estimateMissingWage,
			});
			return result.data;
		},
		enabled,
		...MC_QUERY_DEFAULTS,
	});
};
